<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <h3>LaTeX</h3>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="latex">
                <TextareaAutosize
                  type="text"
                  placeholder="LaTeX Script Box"
                  class="latex-text"
                  v-model="latex"
                  @input="onInput"
                  :min-height="30"
                  :max-height="350"
                ></TextareaAutosize>

                <div id="editor-output" ref="mathJaxEl" v-html="output"></div>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <span class="action-icon" @click="wrapText">
                <img src="../img/text.png" class="iconimg" alt="Add Text">
              </span>
              <span class="action-icon" @click="breakLatex">
                <img src="../img/center.png" class="iconimg" alt="Breakline">
              </span>

              <button class="modal-default-button" @click="modalClose()">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: [
    'modalOutput',
    'modalLatex'
  ],
  data () {
    return {
      output: this.modalOutput,
      latex: this.modalLatex
    }
  },
  mounted () {
    this.renderOutput()
  },
  methods: {
    cleanText () {
      return this.latex.replace('\\(', '').replace('\\)', '').replace('$$', '').replace('$$', '').replace('YourText', '').replace('YourText', '')
    },
    breakLatex () {
      this.latex = `YourText ${'$$' + this.cleanText() + '$$'} YourText`
      this.renderOutput()
    },
    wrapText () {
      this.latex = `YourText ${'\\(' + this.cleanText() + '\\)'} YourText`
      this.renderOutput()
    },
    renderOutput () {
      if (this.latex) {
        // this.output = '\\(' + this.latex + '\\)'
        this.output = this.latex
        this.$forceUpdate()
        this.$nextTick(() => {
          window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, this.$refs['mathJaxEl']])
        })
      }
    },
    onInput () {
      this.renderOutput()
    },
    modalClose () {
      this.$emit('modalClose', this)
    }
  }
}
</script>

<style scoped>
.latex{
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-bottom: #eeeeee solid 1px;
  border-top: #eeeeee solid 1px;
}
@media screen and (min-width: 767px) {
  .latex{
    flex-direction: row;
  }
}

.latex-text{
  height: 100px;
  min-height: 41px;
  width: 300px;
  margin-bottom: 0px;
}

.iconimg{
  height: 30px;
  cursor: pointer;
  padding: 5px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (max-width: 500px) {
  .latex{
    height: calc(100px + 45px);
  }
  .latex-text{
    height: 100%;
    width: 100%;
  }
  .modal-container {
    width: 200px;
  }
}
</style>
